import React from 'react'
import PropTypes from 'prop-types'

import { GlobalProvider } from 'Shared/global_context'
import configureStore from 'Shared/configure_store'

import { newEditPageReducers } from '../reducers'
import {
  PotentialLeaguesForCloningFactory,
  getInitialState as getInitialStatePotentialLeaguesForCloning,
} from '../reducers/potential_leagues_for_cloning'
import {
  reducerName as LeaguesFilterReducerName,
  getInitialState as getInitialStateLeaguesFilter,
} from '../reducers/leagues_filter_values'
import {
  reducerName as SelectedLeaguesForCloningReducerName,
  getInitialState as getInitialStateSelectedLeaguesForCloning,
} from '../reducers/selected_leagues_for_cloning'
import {
  reducerName as CloningStepsReducerName,
  getInitialState as getInitialStateCloningSteps,
} from '../reducers/cloning_steps'
import {
  reducerName as SessionSaverReducerName,
  getInitialState as getInitialStateSessionSaver,
} from '../reducers/session_saver'
import {
  reducerName as EnhancedLeaguesReducerName,
  getInitialState as getInitialStateEnhancedLeagues,
} from '../reducers/enhanced_leagues'
import {
  reducerName as CloneLeaguesSessionsStarter,
  getInitialState as getInitialStateCloneLeaguesSessionsStarter,
} from '../reducers/clone_league_session_starter'
import {
  reducerName as LeaguesConfigsReducerName,
  getInitialState as getInitialStateLeaguesConfigs,
} from '../reducers/leagues_configs'
import {
  reducerName as LeaguesDatesReducerName,
  getInitialState as getInitialStateLeaguesDates,
} from '../reducers/leagues_dates'

import Footer from '../components/common/Footer'
import { LeaguesTypes } from '../constants'
import LeaguesView from '../components/common/LeaguesView'
import CustomerDateFormat from 'Shared/constants/customerDateFormat'

const CloneLeaguesSessionsNewEdit = ({
  searchLeaguesURL,
  startCloneLeaguesSessionURL,
  indexCloneLeaguesSessionsURL,
  upsertCloneLeaguesSessionURL,
  editCloneLeaguesSessionURL,
  cloneLeaguesSession,
  leagues,
  enhancedLeagues,
  outdatedLeagues,
  categories,
  seasons,
  currentSeason,
  productTypes,
  pagination,
  tours,
  customerDateFormat,
}) => {
  const state = {
    [SelectedLeaguesForCloningReducerName]: getInitialStateSelectedLeaguesForCloning(cloneLeaguesSession),
    [LeaguesFilterReducerName]:
      getInitialStateLeaguesFilter({
        categories: categories,
        productTypes: productTypes,
        seasons: seasons,
        currentSeason: currentSeason,
        tours: tours,
      }),
    [PotentialLeaguesForCloningFactory.name]:
      getInitialStatePotentialLeaguesForCloning({
        leagues,
        pagination,
        searchLeaguesURL,
      }),
    [CloningStepsReducerName]: getInitialStateCloningSteps(cloneLeaguesSession, { outdatedLeagues }),
    [EnhancedLeaguesReducerName]: getInitialStateEnhancedLeagues({
      searchLeaguesURL,
      enhancedLeagues,
    }),
    [CloneLeaguesSessionsStarter]: getInitialStateCloneLeaguesSessionsStarter({
      startCloneLeaguesSessionURL,
      indexCloneLeaguesSessionsURL,
    }),
    [LeaguesConfigsReducerName]: getInitialStateLeaguesConfigs(cloneLeaguesSession),
    [LeaguesDatesReducerName]: getInitialStateLeaguesDates(),
    [SessionSaverReducerName]: getInitialStateSessionSaver({
      upsertCloneLeaguesSessionURL,
      cloneLeaguesSession,
      editCloneLeaguesSessionURL,
      indexCloneLeaguesSessionsURL,
      customerDateFormat,
    }),
  }

  const store = configureStore(
    newEditPageReducers,
    state,
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
  )

  return (
    <GlobalProvider store={store}>
      <React.Fragment>
        <LeaguesView />
        <Footer />
      </React.Fragment>
    </GlobalProvider>
  )
}

CloneLeaguesSessionsNewEdit.propTypes = {
  searchLeaguesURL: PropTypes.string.isRequired,
  startCloneLeaguesSessionURL: PropTypes.string.isRequired,
  indexCloneLeaguesSessionsURL: PropTypes.string.isRequired,
  upsertCloneLeaguesSessionURL: PropTypes.string.isRequired,
  editCloneLeaguesSessionURL: PropTypes.string.isRequired,
  leagues: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      product: PropTypes.oneOf(Object.values(LeaguesTypes)).isRequired,
    }),
  ).isRequired,
  enhancedLeagues: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      product: PropTypes.oneOf(Object.values(LeaguesTypes)).isRequired,
      rounds: PropTypes.arrayOf(
        PropTypes.shape({
          playAt: PropTypes.string.isRequired,
        }),
      ),
    }),
  ).isRequired,
  categories: PropTypes.object.isRequired,
  seasons: PropTypes.object.isRequired,
  currentSeason: PropTypes.object,
  tours: PropTypes.object,
  productTypes: PropTypes.object.isRequired,
  customerDateFormat: PropTypes.oneOf(Object.values(CustomerDateFormat)),
  outdatedLeagues: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    product: PropTypes.string.isRequired,
  })),
  pagination: PropTypes.object.isRequired,
  cloneLeaguesSession: PropTypes.shape({
    id: PropTypes.string.isRequired,
    data: PropTypes.shape({
      cloningStep: PropTypes.string,
      leagues: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
      })),
    }),
  }),
}

export default CloneLeaguesSessionsNewEdit
